import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;
`

export const Container = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;
`

export const ProgressSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const ProgressDot = styled.span`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: ${({ tone }) => (tone === 'complete' ? '#22c55e' : '#F59E0B')};
`

export const ProgressLabel = styled.span`
  font-size: 20px;
  font-weight: 500;
  color: #111827;
  flex: 1;
`

export const InProgressPill = styled.span`
  padding: 5px 20px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 500;
  color: #1e40af;
  background: #dbeafe;
`

export const ProgressBarTrack = styled.div`
  position: relative;
  height: 16px;
  border-radius: 999px;
  background: #d9d9d9;
  margin-bottom: 24px;
`

export const ProgressBarFill = styled.div`
  height: 100%;
  border-radius: 999px;
  background: #f59e0b;
  width: ${({ percent }) => percent}%;
  transition: width 0.3s ease;
`

export const ProgressTarget = styled.div`
  position: absolute;
  top: 0px;
  left: ${({ percent }) => percent}%;
  width: 3px;
  height: 16px;
  background: #1f2937;
`

export const ProgressTargetLabel = styled.div`
  position: absolute;
  top: 20px;
  left: ${({ percent }) => percent - 5}%;
  font-size: 16px;
  color: #444444;
`

export const StatsRow = styled.div`
  display: grid;
  grid-template-columns: ${({ $columns }) => ($columns ? `repeat(${$columns}, 1fr)` : 'repeat(3, 1fr)')};
  gap: 16px;
`

export const StatCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 24px;
`

export const StatLabel = styled.div`
  font-size: 14px;
  color: #444444;
`

export const StatValue = styled.div`
  font-size: 40px;
  line-height: 36px;
  font-weight: 700;
  color: #111827;

  span {
    font-size: 30px;
    font-weight: 400;
    color: #111827;
  }
`

export const ChartsRow = styled.div`
  display: grid;
  grid-template-columns: ${({ $columns }) => ($columns === 1 ? '1fr' : 'repeat(2, 1fr)')};
  gap: 20px;
`

export const EmptyCard = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 48px 24px;
  background: #ffffff;
  color: #6b7280;
  font-size: 16px;
  font-weight: 500;
`

